export function useSensitiveInfo() {
  const sensitiveHelpVisible = useState<boolean>(
    'sensitive-help-visible',
    () => false,
  );

  function showSensitiveHelp(): void {
    sensitiveHelpVisible.value = true;
  }

  function hideSensitiveHelp(): void {
    sensitiveHelpVisible.value = false;
  }

  return {
    sensitiveHelpVisible,
    showSensitiveHelp,
    hideSensitiveHelp,
  };
}
